export default [
    'companyTicker',
    'companyName',
    'stockExchange',
    'currentPrice',
    'changePrice',
    'marketCloseDate'
];
